module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-449.ea01037.woff2";